import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "@/pages/home/components/PageLayout";
import BlogSNSSection from "@/pages/home/components/BlogSNSSection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function BlogPage() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  usePageMeta({
    title: "Links & SNS | むぎ茶プロダクション",
    description:
      "むぎ茶のSNS・ブログ・リンクまとめページ。note・旧ブログ・lit.link・X（Twitter）のメイン／サブ／お仕置きBAR公式アカウントを一覧でご確認いただけます。",
    keywords: "むぎ茶,Mugi Cha Production,SNS,lit.link,note,X,Twitter,links",
    canonical: "https://mugichaproduction.com/links-sns",
  });

  useEffect(() => {
    document.title = "Links & SNS | むぎ茶プロダクション";
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // スマホ版で /links-sns に直接アクセスした場合、/ にリダイレクトして #blog までスクロール
  useEffect(() => {
    if (isMobile) {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("blog");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [isMobile, navigate]);

  // PC版のみ：単独ページとして表示
  return (
    <PageLayout>
      <BlogSNSSection />
    </PageLayout>
  );
}